import api from "../apis/selectree_api";
import { getAuthHeader } from "../utilities/header";

export const deleteTaxon = taxonId => async dispatch => {
  try {
    if (taxonId) {
      const response = await api.delete(`/tree/taxon/delete/${taxonId}`);
      return dispatch({ type: "DELETE_TAXON", payload: response });
    } else {
      throw new Error("no id provided");
    }
  } catch (err) {
    console.log(`Error in client.actions.taxon: ${err}`);
    return dispatch({ type: "DELETE_TAXON", payload: [] });
  }
};

export function addTaxonThunk(tree_id) {
  return async dispatch => {
    return api.post(`/tree/taxon/add/${tree_id}`, {}, getAuthHeader()).then(
      response => {
        dispatch({
          type: "TREE_DETAIL_ADD_NEW_TAXA",
          payload: response.data,
        });
        return response;
      },
      error => error.response
    );
  };
}
